import { Injectable, signal } from '@angular/core';
import { MessageType } from '../models/message-type.type';

@Injectable({ providedIn: 'root' })
export class MessageService {
  readonly #isVisible = signal(false);
  readonly #message = signal<string | null>(null);
  readonly #type = signal<MessageType | null>(null);

  readonly isVisible = this.#isVisible.asReadonly();
  readonly message = this.#message.asReadonly();
  readonly type = this.#type.asReadonly();

  show(message: string, type: MessageType = 'info', duration = 4000): void {
    this.#message.set(message);
    this.#type.set(type);
    this.#isVisible.set(true);
    setTimeout(() => this.hide(), duration);
  }

  hide(): void {
    this.#isVisible.set(false);
    this.#message.set(null);
    this.#type.set(null);
  }

  info(message: string, durationMs = 4000): void {
    this.show(message, 'info', durationMs);
  }

  warning(message: string, durationMs = 4000): void {
    this.show(message, 'warning', durationMs);
  }

  error(message: string, durationMs = 4000): void {
    this.show(message, 'error', durationMs);
  }
}
